import { render, staticRenderFns } from "./RiskStatistics.vue?vue&type=template&id=6d59ea20&scoped=true"
import script from "./RiskStatistics.vue?vue&type=script&lang=js"
export * from "./RiskStatistics.vue?vue&type=script&lang=js"
import style0 from "./RiskStatistics.vue?vue&type=style&index=0&id=6d59ea20&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d59ea20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d59ea20')) {
      api.createRecord('6d59ea20', component.options)
    } else {
      api.reload('6d59ea20', component.options)
    }
    module.hot.accept("./RiskStatistics.vue?vue&type=template&id=6d59ea20&scoped=true", function () {
      api.rerender('6d59ea20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/new-column/column-m/form/RiskStatistics.vue"
export default component.exports